import Button from '@polyai/ui/components/atoms/Button';

interface BannerButtonProps {
  label: string;
  onClick: () => void;
  pendoId?: string;
}

const BannerButton = ({ label, onClick, pendoId }: BannerButtonProps) => (
  <Button
    size="small"
    variant="BRAND"
    label={label}
    className="flex-none"
    onClick={onClick}
    data-pendo-id={pendoId}
  />
);

export default BannerButton;
